var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVk = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  rx: 4,
  fill: "#4680C2"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.482 11.902c.163-.509 0-.879-.722-.879h-2.4c-.606 0-.885.324-1.048.671 0 0-1.235 2.96-2.96 4.88-.559.556-.815.74-1.118.74-.163 0-.373-.184-.373-.693v-4.742c0-.601-.186-.879-.699-.879h-3.774c-.373 0-.606.278-.606.555 0 .579.862.717.955 2.337v3.515c0 .764-.14.903-.442.903-.816 0-2.796-2.984-3.985-6.385-.233-.67-.466-.925-1.071-.925H6.815c-.699 0-.815.324-.815.67 0 .625.815 3.771 3.798 7.935 1.98 2.845 4.8 4.372 7.34 4.372 1.537 0 1.723-.347 1.723-.925V20.9c0-.694.14-.81.63-.81.349 0 .978.186 2.4 1.55C23.52 23.26 23.8 24 24.71 24h2.4c.698 0 1.025-.347.838-1.018-.21-.67-1.002-1.642-2.027-2.799-.559-.647-1.398-1.364-1.654-1.712-.35-.462-.256-.647 0-1.064-.023 0 2.912-4.117 3.215-5.505z",
  fill: "#fff"
})));
export { SvgVk as ReactComponent };